<div class="chat-prompt-input">
  <input
    type="text"
    [disabled]="isTyping"
    [(ngModel)]="userInput"
    (keydown.enter)="sendMessage()"
    placeholder="Type your query..."
  />
  <mat-icon
    [ngClass]="{
      cursor_pointer: userInput.length > 0,
      'ms-2': true,
      active: userInput.length > 0
    }"
    (click)="sendMessage()"
    >send</mat-icon
  >
</div>
